import React, { Component } from 'react';
import { connect } from 'react-redux';
import Ionicon from "react-ionicons";
import SideNavTopBar from "./sidenavTopBar";
import SideNavExpandableList from "./sideNavExpandableList";
import SideNavLink from "./sideNavLink";

import { logOutToken } from '../../../actions/app_token'

/*
Configure what is displayed in the side nav here
*/
class SideNavBar extends Component {
  componentWillMount(){
    if (!this.props.signedIn){
      return this.props.history.push("/")
    }
  }

  render() {
    const {location} = this.props

    if(location.pathname === "/") {
      return ""
    }
    return (
      <div
        id="layout-sidenav"
        className="layout-sidenav sidenav sidenav-vertical bg-dark overflow-auto"
      >
        <SideNavTopBar />
        <div className="sidenav-divider mt-0" />
        <ul className="sidenav-inner py-1 ps">
          <SideNavLink
            title="SHEC Observation"
            icon={
              <Ionicon icon="md-list-box" className="sidenav-icon" color="#9d9fa1" />
            }
            link="/shec_observation"
          />
          <SideNavLink
            title="Fuel Tracker"
            icon={
              <Ionicon icon="md-battery-charging" className="sidenav-icon" color="#9d9fa1" />
            }
            link="/fuel_tracker"
          />
          <SideNavLink
            title="Vehicle Pre-Start"
            icon={
              <Ionicon icon="md-car" className="sidenav-icon" color="#9d9fa1" />
            }
            link="/vehicle_pre_start"
          />
          <SideNavLink
            title="VFL"
            icon={
              <Ionicon icon="ios-man" className="sidenav-icon" color="#9d9fa1" />
            }
            link="/vfl"
          />
          <SideNavLink
            title="Community Engagement Card"
            icon={
              <Ionicon icon="ios-people" className="sidenav-icon" color="#9d9fa1" />
            }
            link="/community_engagement_card"
          />

          {
            this.props.isManager &&
            <span>
              <div className="sidenav-divider mb-1" />
              <ul className="sidenav-inner py-1 ps">
                <li className="sidenav-header font-weight-semibold">{ "MANAGER VIEW" }</li>
                <SideNavLink
                  title="SHEC Observation"
                  icon={
                    <Ionicon icon="md-list-box" className="sidenav-icon" color="#9d9fa1" />
                  }
                  link="/manager/shec_observation"
                />
                <SideNavLink
                  title="Fuel Tracker"
                  icon={
                    <Ionicon icon="md-battery-charging" className="sidenav-icon" color="#9d9fa1" />
                  }
                  link="/manager/fuel_tracker"
                />
                <SideNavLink
                  title="Vehicle Pre-Start"
                  icon={
                    <Ionicon icon="md-car" className="sidenav-icon" color="#9d9fa1" />
                  }
                  link="/manager/vehicle_pre_start"
                />
                <SideNavLink
                  title="VFL"
                  icon={
                    <Ionicon icon="ios-man" className="sidenav-icon" color="#9d9fa1" />
                  }
                  link="/manager/vfl"
                />
                <SideNavLink
                  title="Community Engagement Card"
                  icon={
                    <Ionicon icon="ios-people" className="sidenav-icon" color="#9d9fa1" />
                  }
                  link="/manager/community_engagement_card"
                />
              </ul>
            </span>
          }

          <div className="sidenav-divider mt-0" />
          <ul className="sidenav-inner py-1 ps">
            <li className="sidenav-item">
              <a className="sidenav-link cursor-pointer"
                onClick={ () => this.props.logout(this.props.token)}
              >
                <Ionicon icon="md-exit" className="sidenav-icon" color="#9d9fa1" />
                Logout
              </a>
            </li>
          </ul>
        </ul>
      </div>
    )
  }
};

const mapStateToProps = (state) => {
  return {
    token: state.app_token.accessToken,
    signedIn: state.app_token.signedIn,
    isManager: state.app_token.isManager,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logout: (token) => {
      dispatch(logOutToken(token))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SideNavBar)



// WEBPACK FOOTER //
// ./src/views/components/sidenav/sidenav.js